module.exports = "/assets/066d3e854740e4bcd798207286f3c2d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/DL.png
// module id = 2432
// module chunks = 0